import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AppCommonModule } from "src/app/common.module";
import { ConfirmDeactivateGuard } from "src/commons/guards";
import { PlantPlanetRouter } from "./plant-planet.router";
import { PlantPlanetEffects } from "./state/plant-planet.effects";
import { reducers } from "./state/plant-planet.selectors";



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PlantPlanetRouter,
    AppCommonModule,
    StoreModule.forFeature('plantPlanet', reducers),
    EffectsModule.forFeature([PlantPlanetEffects]),
  ],
  providers: [ConfirmDeactivateGuard],
  declarations: []
})
export class PlantPlanetScreenModule { }